import { ViewOption } from 'types/viewOptions';
import AdListGridItem from './AdListGridItem';
import AdListFlatItem from './AdListFlatItem';
import AdListHeader from './AdListHeader';
import { SortingOptions } from 'types/sortingOptions';
import { AdListing } from 'types/adListing';

interface AdListProps {
  sortedIlanlar: AdListing[];
  itemsPerPage: number;
  currentPage: number;
  totalPages: number;
  sortOption: SortingOptions;
  handleSortChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  viewType: ViewOption;
  handleViewChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  detailLinkBase?: string;
  onToggleFavorite?: (id: string | number, e: React.MouseEvent) => void;
  displayFavorites?: boolean;
  displayEdit?: boolean;
  displayDelete?: boolean;
  /** Optional content at the start of the header (e.g. mobile filter toggle button) */
  headerLeftAddon?: React.ReactNode;
}

export default function AdList({
  sortedIlanlar,
  itemsPerPage,
  currentPage,
  totalPages,
  sortOption,
  handleSortChange,
  viewType = ViewOption.GRID,
  handleViewChange,
  detailLinkBase,
  onToggleFavorite,
  displayFavorites = true,
  displayEdit = false,
  displayDelete = false,
  headerLeftAddon,
}: AdListProps) {
  const currentItems = sortedIlanlar;
  return (
    <>
      <AdListHeader sortedIlanlar={sortedIlanlar} itemsPerPage={itemsPerPage} currentPage={currentPage} totalPages={totalPages} sortOption={sortOption} viewType={viewType} handleSortChange={handleSortChange} handleViewChange={handleViewChange} leftAddon={headerLeftAddon} />

      {viewType === ViewOption.GRID && (
        <div className="row row-cols-1 row-cols-lg-2 row-cols-xl-3 g-4">
          {currentItems.map((ilan) => (
            <AdListGridItem
              key={ilan.id}
              ilan={ilan}
              detailLinkBase={detailLinkBase}
              onToggleFavorite={onToggleFavorite}
              displayFavorites={displayFavorites}
              displayEdit={displayEdit}
              displayDelete={displayDelete}
            />
          ))}
        </div>
      )}
      {viewType === ViewOption.LIST && (
        <div className="list-view">
          {currentItems.map((ilan) => (
            <AdListFlatItem
              key={ilan.id}
              ilan={ilan}
              detailLinkBase={detailLinkBase}
              onToggleFavorite={onToggleFavorite}
              displayFavorites={displayFavorites}
            />
          ))}
        </div>
      )}
    </>
  )
}